import { z } from 'zod';
import { buildEvidenceFieldSchema } from './buildEvidenceFieldSchema.js';

export const buildAppFlawEvidenceSchema = (flaw) => {
  const shape = { detail: z.string().optional() };
  for (const alternative of flaw.evidenceAlternatives) {
    for (const [key, field] of Object.entries(alternative)) {
      const fieldSchema = buildEvidenceFieldSchema(field);
      shape[key] = shape[key] ? z.union([shape[key], fieldSchema]).optional() : fieldSchema.optional();
    }
  }
  for (const [key, field] of Object.entries(flaw.requiredEvidence)) {
    shape[key] = buildEvidenceFieldSchema(field);
  }

  return z
    .object(shape)
    .strict()
    .superRefine((evidence, context) => {
      if (
        flaw.evidenceAlternatives.length &&
        !flaw.evidenceAlternatives.some(
          (alternative) =>
            z
              .object(Object.fromEntries(Object.entries(alternative).map(([key, field]) => [key, buildEvidenceFieldSchema(field)])))
              .passthrough()
              .safeParse(evidence).success
        )
      ) {
        context.addIssue({ code: z.ZodIssueCode.custom, message: 'One complete evidence alternative is required.' });
      }
      for (const relation of flaw.evidenceRelations) {
        if (evidence[relation.left] === undefined) {
          continue;
        }
        if (relation.operator === 'subset') {
          if (!Array.isArray(evidence[relation.left]) || !Array.isArray(evidence[relation.right]) || !evidence[relation.left].every((value) => evidence[relation.right].includes(value))) {
            context.addIssue({ code: z.ZodIssueCode.custom, path: [relation.left], message: `${relation.left} must reference ${relation.right}.` });
          }
          continue;
        }
        if (relation.operator !== 'notEqual') {
          throw new Error(`Unsupported app flaw evidence relation: ${relation.operator}`);
        }
        if (evidence[relation.right] === undefined || evidence[relation.left] === evidence[relation.right]) {
          context.addIssue({ code: z.ZodIssueCode.custom, path: [relation.left], message: `${relation.left} must differ from ${relation.right}.` });
        }
      }
    });
};
